import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { getRootError, isHubHttpError } from '../../../utils/error';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const refresh = () => window.location.reload();
export const ActivationErrorModal = ({
  apiName,
  error,
  onStartSuccess
}) => {
  var _ref, _rootError$responseJS;
  const rootError = getRootError(error);
  const errorMessage = (_ref = isHubHttpError(rootError) && rootError !== null && rootError !== void 0 && (_rootError$responseJS = rootError.responseJSON) !== null && _rootError$responseJS !== void 0 && _rootError$responseJS.message ? rootError.responseJSON.message : rootError.message) !== null && _ref !== void 0 ? _ref : '';
  if (errorMessage.match(/^Cannot start this trial because it is already active on this hub/)) {
    return /*#__PURE__*/_jsxs(Modal, {
      centered: true,
      size: "auto",
      use: "success",
      width: 600,
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h2",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.duplicateErrorTitle",
            options: {
              apiName: I18n.text(`purchaseMotions.products.${apiName}`)
            }
          })
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        align: "center",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "300",
          maxInlineSize: "450px",
          marginBlockEnd: "300",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.activationModal.trialStartSubtitle"
          }), /*#__PURE__*/_jsx(Button, {
            block: true,
            use: "primary",
            onClick: onStartSuccess,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "purchaseMotions.trial.activationModal.startSetup"
            })
          })]
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Modal, {
    size: "auto",
    use: "conversational",
    width: 500,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: refresh
    }), /*#__PURE__*/_jsx(DialogBody, {
      marginBlockStart: "1000",
      children: /*#__PURE__*/_jsxs(ErrorMessage, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `purchaseMotions.trial.errorTitle`
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `purchaseMotions.trial.errorMessage`
          })
        })]
      })
    })]
  });
};